import styled from 'styled-components';

const ButtonGroup = styled.div`
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
`;

export default ButtonGroup;



// WEBPACK FOOTER //
// ./src/components/Donation/Form/ButtonGroup.jsx